/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_912e2fe6"]'><cube-button icon="like" tip="辅助文案" primary outline :class='["mt10"]'>主要文案</cube-button></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_912e2fe6"}'>
.mt10
  margin-top 10px
  display block
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_912e2fe6"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_912e2fe6"}
  /** script content **/
  require("./btn-with-tip.mpx.js?isComponent&outputPath=components%2Fbtn-with-tip912e2fe6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-with-tip.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-with-tip912e2fe6%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_912e2fe6"],
    ctorType: "component",
    outputPath: "components/btn-with-tip912e2fe6/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>